<div [formGroup]="formGroup">
  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 field-wrapper text-sm-left dropdown-label"
         mbFloatingLabel
         data-cy="mb-checkout-address-state">
      <label for="region"
             class="mandatory-input-asterisk mb-custom-label">{{ regionLabelKey | cxTranslate}}</label>
      <input class="w-100 mb-form-input"
             id="region"
             name="region"
             data-cy="mb-checkout-state-selection"
             type="text"
             [value]="selectedRegion?.name ?? ''"
             [ngbTypeahead]="search"
             [editable]="false"
             (selectItem)="onStateSelection($event?.item)"
             (focus)="onFocus($event)"
             (blur)="updatedSelectedStateOnBlur()"
             [class.ng-invalid]="formGroup?.get(constants.REGION_CODE).invalid"/>
      <mb-form-errors [control]="formGroup?.get(constants.REGION_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>
  </div>
</div>
